import { RoleGuard } from '../guards';
import MentorProfile from '../../pages/mentor/profile';
import MentorHelpCenter from '../../pages/mentor/helpcenter';
import MentorAddressBook from '../../pages/mentor/addressbook';
import MentorWorkingInProgress from '../../pages/mentor/wip';


export const MentorRoutes = () => {

	return ([
		
		// Start - Profile
		{ path: 'profile', element: <RoleGuard roles={["Mentor"]}><MentorProfile /></RoleGuard>},
		{ path: 'helpcenter', element: <RoleGuard roles={["Mentor"]}><MentorHelpCenter /></RoleGuard>},
		{ path: 'address', element: <RoleGuard roles={["Mentor"]}><MentorAddressBook /></RoleGuard>},
		{ path: 'wip', element: <RoleGuard roles={["Mentor"]}><MentorWorkingInProgress /></RoleGuard>},
			
	
		
		// End - Profile
		// Start - Work In Progress
		{ path: 'venture', element: <RoleGuard roles={["Mentor"]}><MentorWorkingInProgress /></RoleGuard>},
		{ path: 'community', element: <RoleGuard roles={["Mentor"]}><MentorWorkingInProgress /></RoleGuard>},
		{ path: 'OneXProjects', element: <RoleGuard roles={["Mentor"]}><MentorWorkingInProgress /></RoleGuard>},
        
	])	
};
